import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeComponentProps as _mergeComponentProps, mergeProps as _mergeProps, mergeExternalProps as _mergeExternalProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("mobile-cta__linkbuttontypography-12ijvd", {
  flexGrow: 1,
  textAlign: "center",
  padding: "0 3px 7px 10px",
  whiteSpace: "nowrap"
});
const _staticStyles2 = _cssRef("mobile-cta__linkbuttonskeleton-2ocz2o", {
  maxWidth: "120px",
  margin: "0 auto",
  height: "16px"
});
const _staticStyles3 = _cssRef("mobile-cta__ctawrapper-3mhsa7", {
  width: "100%"
});
const _staticStyles4 = _cssRef("mobile-cta__container-159b06", {
  height: "60px"
});
const _staticStyles5 = _cssRef("mobile-cta__phonelink-0yp21u", {
  display: "flex",
  position: "relative",
  paddingTop: "16px",
  paddingBottom: "16px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%"
});
const _staticStyles6 = _cssRef("mobile-cta__phonelinkcontainer-1iyr79", {
  display: "flex",
  position: "relative",
  alignItems: "center"
});
const _staticStyles7 = _cssRef("mobile-cta__phonelinkicon-08ft2c", {
  fill: "currentColor",
  height: "14px"
});
const _staticStyles8 = _cssRef("mobile-cta__phonelinktypography-08drfn", {
  marginLeft: "10px",
  "& span": {
    lineHeight: 1
  }
});
const _staticStyles9 = _cssRef("mobile-cta__opendrawerbutton-0yp21u", {
  display: "flex",
  position: "relative",
  paddingTop: "16px",
  paddingBottom: "16px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%"
});
const _staticStyles0 = _cssRef("mobile-cta__ctabottomphonenumberscontainer-159b06", {
  height: "60px"
});
const _staticStyles1 = _cssRef("mobile-cta__ctabottomphonenumbers-02on3k", {
  paddingLeft: "10px",
  paddingRight: "10px",
  display: "flex",
  paddingTop: "8px",
  "& a:nth-of-type(2):before": {
    content: "\"\"",
    display: "block",
    opacity: 0.4,
    width: "1px",
    height: "40px",
    background: "currentColor",
    position: "absolute"
  }
});
import React from 'react';
import IconPhone from '../../../images/svg/phone.svg';
import { PHONE_NUMBER } from '../../../constants';
import { useCtaProvider } from '../../../contexts/franchise/cta-provider';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import formatPhoneLink, { toTelHref } from '../../utils/format-phone-link';
import Link from '../../primitives/link';
import { colors } from '../../primitives/colors';
import Skeleton from '../../primitives/skeleton';
import { useLocator } from '../../../contexts/franchise/locator-provider';
import Container from '../../primitives/grid/container';
import Typography from '../../primitives/typography';
const styles = {
  linkButtonTypography: _staticStyles,
  linkButtonSkeleton: _staticStyles2,
  ctaWrapper: _staticStyles3,
  container: _staticStyles4,
  phoneLink: _staticStyles5,
  phoneLinkContainer: _staticStyles6,
  phoneLinkIcon: _staticStyles7,
  phoneLinkTypography: _staticStyles8,
  openDrawerButton: _staticStyles9,
  ctaBottomPhoneNumbersContainer: _staticStyles0,
  ctaBottomPhoneNumbers: _staticStyles1
};
const LinkButton = ({
  phone,
  loading,
  text
}: {
  phone: string;
  loading: boolean;
  text: string;
}): JSX.Element => {
  const ariaLabel = phone && !loading ? `Call ${text} at ${formatPhoneLink(phone)}` : `Call ${text}`;
  return <Typography {..._mergeComponentProps({
    as: Link,
    fontSize: "sm",
    fontWeight: "medium",
    css: styles.linkButtonTypography,
    to: toTelHref(phone) || 'tel:',
    "aria-label": ariaLabel
  })}>
            {text}
            {' '}
            <br />
            {phone && !loading ? <span>
                    {formatPhoneLink(phone)}
                </span> : <Skeleton {..._mergeComponentProps({
      css: styles.linkButtonSkeleton
    })} />}
        </Typography>;
};
const MobileCta = ({
  inverse,
  setOpen
}: {
  inverse?: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element | null => {
  const {
    isMicrosite,
    franchise: micrositeFranchise,
    isLocalCityPage
  } = useMicrosite();
  const {
    franchise: locatorFranchise,
    loading,
    isNationalCallCenter
  } = useLocator();
  const {
    hideNationalCallCenter,
    hideFranchiseLink,
    overridePhoneNumber,
    overridePhoneNumberDescriptor
  } = useCtaProvider();

  // Memoize inline styles to prevent creating new objects on every render
  // MUST be before early return to follow Rules of Hooks
  const ctaWrapperStyles = React.useMemo(() => ({
    color: inverse ? colors.primaryOrange : colors.shadesWhite,
    backgroundColor: inverse ? colors.shadesWhite : colors.primaryOrange
  }), [inverse]);
  if (!!hideNationalCallCenter && !!hideFranchiseLink && !overridePhoneNumber) {
    return null;
  }
  const franchise = micrositeFranchise || locatorFranchise?.data;
  const phone = franchise?.mainPhone;
  const bottomContentHidden = isLocalCityPage || isMicrosite || !!hideNationalCallCenter || !!hideFranchiseLink;
  const phoneNumberLink: string = (() => {
    if (overridePhoneNumber) {
      return toTelHref(overridePhoneNumber);
    }
    if (hideFranchiseLink) {
      return toTelHref(PHONE_NUMBER);
    }
    if (phone) {
      return toTelHref(phone);
    }
    return toTelHref(PHONE_NUMBER);
  })();
  const displayPhoneNumber: string = (() => {
    if (overridePhoneNumber && overridePhoneNumberDescriptor) {
      return overridePhoneNumberDescriptor;
    }
    if (overridePhoneNumber) {
      return `Call: ${formatPhoneLink(overridePhoneNumber)}}`;
    }
    if (hideFranchiseLink) {
      return 'National Call Center';
    }
    if (isMicrosite || isLocalCityPage) {
      return `Call: ${formatPhoneLink(phone)}`;
    }
    return 'Call for Service';
  })();
  const topText: string = (() => {
    if (isMicrosite || isLocalCityPage) {
      if (franchise?.tempOutOfService && !overridePhoneNumber) {
        return 'National Call Center';
      }
    }
    return '';
  })();
  return <div {..._mergeProps({
    css: styles.ctaWrapper,
    style: ctaWrapperStyles
  })}>
            <Container {..._mergeComponentProps({
      css: styles.container
    })}>
                {bottomContentHidden && <Link {..._mergeComponentProps({
        to: phoneNumberLink,
        css: styles.phoneLink
      })}>
                        {topText && <p>{topText}</p>}
                        <div {..._mergeProps({
          css: styles.phoneLinkContainer
        })}>
                            <IconPhone {..._mergeExternalProps({
            css: styles.phoneLinkIcon,
            "aria-hidden": "true",
            focusable: "false"
          })} />
                            <Typography {..._mergeComponentProps({
            fontSize: "xl",
            fontWeight: "medium",
            css: styles.phoneLinkTypography
          })}>
                                <span>{displayPhoneNumber}</span>
                            </Typography>
                        </div>
                    </Link>}
                {!bottomContentHidden && <button {..._mergeProps({
        type: "button",
        css: styles.openDrawerButton,
        onClick: () => setOpen(true)
      })}>
                        {topText && <p>{topText}</p>}
                        <div {..._mergeProps({
          css: styles.phoneLinkContainer
        })}>
                            <IconPhone {..._mergeExternalProps({
            css: styles.phoneLinkIcon,
            "aria-hidden": "true",
            focusable: "false"
          })} />
                            <Typography {..._mergeComponentProps({
            fontSize: "xl",
            fontWeight: "medium",
            css: styles.phoneLinkTypography
          })}>
                                <span>{displayPhoneNumber}</span>
                            </Typography>
                        </div>
                    </button>}
            </Container>
            {!bottomContentHidden && <Container {..._mergeComponentProps({
      css: styles.ctaBottomPhoneNumbersContainer
    })}>
                    <div {..._mergeProps({
        css: styles.ctaBottomPhoneNumbers
      })}>
                        {!hideFranchiseLink && !isLocalCityPage && !isNationalCallCenter && <LinkButton phone={phone || ''} loading={loading} text="Your Local SERVPRO" />}
                        {!hideNationalCallCenter && !hideFranchiseLink && <LinkButton phone={PHONE_NUMBER} loading={false} text="National Call Center" />}
                    </div>
                </Container>}
        </div>;
};
export default MobileCta;